import { Icon } from '@acast-tech/decibel';
import { ArrowUpRightFromSquareLightGlyph } from '@acast-tech/decibel-glyphs';
import { config } from '@/config';
import { mixpanelTrack, RevenueDashboardWidget } from '@/utils';
import { MIXPANEL_EVENT } from '@/utils/mixpanelUtils/events';

export const ConnectProfilesMessage = ({
  networkId,
  showId,
}: {
  networkId: string;
  showId: string;
}) => {
  const handleClickLink = () => {
    mixpanelTrack(MIXPANEL_EVENT.audience.socialProfiles.connectMarketplaceProfilesClicked, {
      widget: RevenueDashboardWidget.SocialProfiles,
      page: 'audience',
    });
  };
  return (
    <div className="flex flex-row items-start justify-center w-full lg:w-[430px] justify-self-end bg-gradient-to-r from-[#FFFDF3] to-[#FFF6D0] p-6">
      <LightBulbIcon />
      <div className="ml-2">
        <p className="text-sm mb-0 font-medium">
          Data for your audio, video and socials in one place
        </p>
        <p className="text-sm text-[#4F4F4F] mb-4">
          Connect your show's accounts to your marketplace profile for cross-channel insights.
        </p>
        <a
          className="flex"
          href={`${config.cmsUrl}/networks/${networkId}/shows/${showId}/marketplace`}
          target="_blank"
          rel="noreferrer"
          onClick={handleClickLink}
        >
          <p className="text-sm mt-0.5 mb-0 font-medium">Add YouTube, Instagram and TikTok</p>
          <Icon glyph={ArrowUpRightFromSquareLightGlyph} className="ml-2" />
        </a>
      </div>
    </div>
  );
};

const LightBulbIcon = () => (
  <svg
    className="w-10 h-4 mt-0.5"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="19"
    viewBox="0 0 24 19"
    fill="none"
  >
    <path
      d="M12 0C15.975 0 19.2 3.19141 19.2 7.125C19.2 9.025 18.45 10.7506 17.2238 12.0271C16.3388 12.9512 15.6 14.0793 15.6 15.3521V16.0312C15.6 17.6715 14.2575 19 12.6 19H11.4C9.7425 19 8.4 17.6715 8.4 16.0312V15.3521C8.4 14.0793 7.66125 12.9512 6.77625 12.0271C5.55 10.7506 4.8 9.025 4.8 7.125C4.8 3.19141 8.025 0 12 0ZM9.6 16.0312C9.6 17.0146 10.4062 17.8125 11.4 17.8125H12.6C13.5938 17.8125 14.4 17.0146 14.4 16.0312V15.4375H9.6V16.0312ZM12 1.1875C8.685 1.1875 6 3.84453 6 7.125C6 8.70957 6.62625 10.1457 7.64625 11.2107C8.3925 11.9863 9.16125 13.018 9.465 14.25H14.5387C14.8425 13.018 15.6113 11.9863 16.3575 11.2107C17.3775 10.1457 18.0037 8.70957 18.0037 7.125C18.0037 3.84453 15.3188 1.1875 12.0038 1.1875H12ZM2.66625 11.3814C2.94375 11.1996 3.315 11.2738 3.49875 11.5447C3.6825 11.8156 3.6075 12.1867 3.33375 12.3686L1.53375 13.5561C1.25625 13.7379 0.885 13.6637 0.70125 13.3928C0.5175 13.1219 0.5925 12.7508 0.86625 12.5689L2.66625 11.3814ZM20.5013 11.5447C20.685 11.2701 21.0563 11.1996 21.3338 11.3814L23.1338 12.5689C23.4113 12.7508 23.4825 13.1182 23.2987 13.3928C23.115 13.6674 22.7437 13.7379 22.4662 13.5561L20.6662 12.3686C20.3887 12.1867 20.3175 11.8193 20.5013 11.5447ZM12 11.875C11.5013 11.875 11.1 11.4779 11.1 10.9844C11.1 10.4908 11.5013 10.0938 12 10.0938C12.4987 10.0938 12.9 10.4908 12.9 10.9844C12.9 11.4779 12.4987 11.875 12 11.875ZM12 3.5625C12.51 3.5625 12.9113 3.99297 12.8775 4.49395L12.6 8.35332C12.5775 8.66504 12.315 8.90625 12 8.90625C11.685 8.90625 11.4225 8.66504 11.4 8.35332L11.1225 4.49395C11.085 3.98926 11.49 3.5625 12 3.5625ZM2.4 6.53125C2.73 6.53125 3 6.79844 3 7.125C3 7.45156 2.73 7.71875 2.4 7.71875H0.6C0.27 7.71875 0 7.45156 0 7.125C0 6.79844 0.27 6.53125 0.6 6.53125H2.4ZM23.4 6.53125C23.73 6.53125 24 6.79844 24 7.125C24 7.45156 23.73 7.71875 23.4 7.71875H21.6C21.27 7.71875 21 7.45156 21 7.125C21 6.79844 21.27 6.53125 21.6 6.53125H23.4ZM0.70125 0.857227C0.885 0.582617 1.25625 0.512109 1.53375 0.693945L3.33375 1.88145C3.61125 2.06328 3.6825 2.43066 3.49875 2.70527C3.315 2.97988 2.94375 3.05039 2.66625 2.86855L0.86625 1.68105C0.58875 1.49922 0.5175 1.13184 0.70125 0.857227ZM22.4662 0.693945C22.7437 0.512109 23.115 0.586328 23.2987 0.857227C23.4825 1.12812 23.4075 1.49922 23.1338 1.68105L21.3338 2.86855C21.0563 3.05039 20.685 2.97617 20.5013 2.70527C20.3175 2.43437 20.3925 2.06328 20.6662 1.88145L22.4662 0.693945Z"
      fill="black"
    />
  </svg>
);
